export default __webpack_public_path__ + "static/media/30.0e43f438.svg";